import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { teamPageService, TeamPage } from './team-page-service'
import { toast } from 'sonner'

export function useTeamPage() {
    const queryClient = useQueryClient()

    const { data: teamPage, isLoading } = useQuery({
        queryKey: ['team-page'],
        queryFn: teamPageService.getTeamPage,
    })

    const updateTeamMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<TeamPage>, translate?: boolean }) =>
            teamPageService.updateTeamPage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['team-page'] })
            toast.success('Ekip sayfası başarıyla güncellendi.')
        },
        onError: (err: any) => {
            toast.error(err.response?.data?.message || 'Güncelleme sırasında bir hata oluştu.')
        },
    })

    const updateTeamPage = async ({ data, translate }: { data: Partial<TeamPage>, translate?: boolean }) => {
        return await updateTeamMutation.mutateAsync({ data, translate });
    };

    return {
        teamPage,
        isLoading,
        updateTeamPage,
        isUpdating: updateTeamMutation.isPending
    };
}
